import { render } from "./QuickLinksWidget.vue?vue&type=template&id=661b7300"
import script from "./QuickLinksWidget.vue?vue&type=script&lang=js"
export * from "./QuickLinksWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__